const voucherEncoder = (voucherNumber, replaceString = /[/]/g, replaceCode = '%2F') => {
  return voucherNumber.replace(replaceString, replaceCode);
};

const voucherDecoder = (voucherNumber, replaceString = /%2F/g, replaceCode = '/') => {
  return voucherNumber.replace(replaceString, replaceCode);
};

export { voucherEncoder, voucherDecoder };
